import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { PresidioNotificationItem } from '../models/presidio-notification.model';
import {
  clearPresidioMockNotifications,
  getPresidioMockNotifications,
  markAllPresidioMockNotificationsRead,
  markPresidioMockNotificationRead,
  setPresidioMockNotificationRead,
} from '../mock/presidio-mock-notifications';

/**
 * DEMO-ONLY data access for portal notifications.
 * Production later: same method shapes against ICM/API.
 */
@Injectable({ providedIn: 'root' })
export class PresidioNotificationsService {
  list(): Observable<PresidioNotificationItem[]> {
    return of(getPresidioMockNotifications());
  }

  markRead(id: string): Observable<PresidioNotificationItem[]> {
    return of(markPresidioMockNotificationRead(id));
  }

  setRead(id: string, read: boolean): Observable<PresidioNotificationItem[]> {
    return of(setPresidioMockNotificationRead(id, read));
  }

  markAllRead(): Observable<PresidioNotificationItem[]> {
    return of(markAllPresidioMockNotificationsRead());
  }

  clearAll(): Observable<PresidioNotificationItem[]> {
    return of(clearPresidioMockNotifications());
  }
}
